import { Alert, Divider, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";

export const KdappontWebInspector = () => {
  return (
    <Stack direction="row" gap={4} alignItems="center">
      <Box sx={{ width: "50%" }}>
        <Box
          component="video"
          src="presentation-data/KDAPPONT2/web-inspector.mp4"
          autoPlay
          loop
          muted
          sx={{
            width: "100%",
            borderRadius: 2,
            boxShadow: 3,
          }}
        />
      </Box>

      <Stack justifyContent={"center"} gap={2} width="50%">
        <Typography variant="h5">
          De web inspector is een essentiële ontwikkeltool die je helpt bij het
          debuggen van je webapplicatie. Het geeft je toegang tot de broncode
          van de pagina, de netwerkaanvragen, de console en andere nuttige
          informatie. <br />
          <br />
          Een andere krachtige feature is de mogelijkheid om de HTML en CSS
          "live" te bewerken. Dit betekent dat je de pagina kunt aanpassen en
          direct kunt zien hoe de wijzigingen eruitzien. Dit is vooral handig
          voor het testen van verschillende stijlen en lay-outs zonder dat je de
          pagina opnieuw hoeft te laden. <br />
        </Typography>

        <Divider />

        <Alert severity="info" sx={{ mt: 2, alignItems: "center" }}>
          Open de web inspector door met de rechtermuisknop op de pagina te
          klikken en "Inspecteren" te selecteren.
        </Alert>

        <Alert severity="warning" sx={{ alignItems: "center" }}>
          Gebruik je Safari? <br />
          Ga eerst naar "Safari -&gt; Settings... -&gt; Advanced &gt; Show
          features for web developers
        </Alert>
      </Stack>
    </Stack>
  );
};
